module.exports = __webpack_public_path__ + "static/media/logo.1015fd7f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/du/Game/Logo/logo.svg
// module id = 391
// module chunks = 1